export class RegistrationUser {
    name: string;
    jobtitle:string;
    email: string;
    password: string;
    username:string;
    invite:boolean;
  }